const getters = {
  token: state => state.user.token,
  userinfo: state => state.user.userinfo
  // avatar: state => state.user.avatar,
  // loginName: state => state.user.loginName,
  // name: state => state.user.name,
  // openTab: state => state.tabsBar.openTab
}
export default getters
